import MainLayout from './components/layouts/MainLayout/MainLayout';
import ForgotPasswordForm from './components/pages/LoginPage/ForgotPasswordForm/ForgotPasswordForm';
import LoginForm from './components/pages/LoginPage/LoginForm/LoginForm';
import { LoginPageProvider } from './components/pages/LoginPage/LoginPageContext';
import RegistrationForm from './components/pages/LoginPage/RegistrationForm/RegistrationForm';

export default {
  LoginForm,
  LoginPageProvider,
  MainLayout,
  RegistrationForm,
  ForgotPasswordForm,
};
